/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonSharedAssociatedCompaniesQueryResponse,
  GetApiV1PersonSharedAssociatedCompaniesQueryParams,
  GetApiV1PersonSharedAssociatedCompanies400,
  GetApiV1PersonSharedAssociatedCompanies401,
  GetApiV1PersonSharedAssociatedCompanies500,
} from "../../types/personSharedController/GetApiV1PersonSharedAssociatedCompanies.ts";

function getGetApiV1PersonSharedAssociatedCompaniesUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/person/shared/associated-companies` as const,
  };
  return res;
}

/**
 * @description Retorna empresas conveniadas para uso em componentes de seleção, filtradas pelo nome. Quando id é informado, retorna apenas a empresa correspondente. Quando poloId é informado, filtra pelo polo. **(Requer Authorization para autenticação)**
 * @summary Lista de empresas conveniadas para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/associated-companies}
 */
export async function getApiV1PersonSharedAssociatedCompanies(
  params?: GetApiV1PersonSharedAssociatedCompaniesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonSharedAssociatedCompaniesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedAssociatedCompanies400
      | GetApiV1PersonSharedAssociatedCompanies401
      | GetApiV1PersonSharedAssociatedCompanies500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonSharedAssociatedCompaniesUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
